import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import moment from 'moment';
import { useManipulateCalendarType } from '../../../../../../hooks/component/sKPI/useOfSidePanelAddDataserieVariableValue';
import CLabel from '../../../../../Common/CLabel';
import { Dropdown, Icon, TagPicker } from '@fluentui/react';
import { useGetDataSerieValues } from '../../../../../../hooks/services/sKPI/useOfBoard';
import { __HoursValues, __KPIPeriods, __MessageTypes, __ShiftValues, enum__BoardCalendarFilter, enum__FormulaId, enum__KPIAgregationTypes, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import CCurrencyTextBox from '../../../../../Common/CCurrencyTextBox';
import { __OBJECT_STRUCTURE_BoardFilters, __OBJECT_STRUCTURE_GetDataserieValue } from '../../../../../../common/ObjectStructures/sKPI';
import { editDataSerieValue, getBoardVariableDataSerieValues, postDataserieValueLocked } from '../../../../../../services/sKPI/dataserie.service';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import List from '../../../../../Templates/List';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import { useGetDataSerieValue } from '../../../../../../hooks/services/sKPI/useOfDataSerie';
import ListPagination from '../../../../../Templates/List/ListPagination';
import MessageBoxInfoComplex from '../../../../../Common/Message/MessageBoxInfoComplex';
import { checkIfDataserieValueEditDeleteMode, isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../../../common/Helpers';
import PropTypes from 'prop-types';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { Calendar } from 'react-calendar';
import DataserieValueDocumentBox from './DataserieValueDocumentBox';
import { action_setBoardContractFilterComponents_And_Sync_Flag, action_setPageState } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserPropsKpi } from '../../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { _checkSecurityUser, _checkSecurityUser_And_ResponsibleInsert, _checkSecurityUserAux } from '../../../../../../common/Helpers/HLP_Security';
import BoardAppContext from '../../../../../../BoardAppContext';


const SidePanelEditDataserieVariableValue = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const dispatch = useDispatch();
    const { token: currentAuth } = useSelector((state) => state.auth);
    
    const { 
        inputParam_BoardId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerie = null,
        inputParam_ElementType = null,
        inputParam_ElementId = null,
        setBoardVariableDataserieValues = null,
        inputParam_BoardType = null,
        inputParam_UserProps = null
    } = props;

    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);
    const { _systemRoles: systemRoles } = useSelector((state) => state.boardViewComponentsScope);

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showFinishButton, setShowFinishButton] = useState(false);

    const [preventDoubleExecutionAction, setPreventDoubleExecutionAction] = useState(false);
    

    const [documentLinkList, setDocumentLinkList] = useState(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [isInvalidForm, setIsInvalidForm] = useState(false);  
    const [isValidForm, setIsValidForm] = useState({
        v1: true,
        v2: true,
        valueReal: true,
        valueProvisory: true,
        valueBudget: true,
        valueForecast: true,
    });
    
    const [dataserievalueList, setDataserievalueList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetDataSerieValues(inputParam_BoardId, inputParam_DataSerie.elementId, inputParam_DataSerie.dataserieId, contextSite.kpiModule.boardCalendarFilterConfig.value, dataserievalueList, setDataserievalueList, inputParam_IsPanelOpen)
    
    const [objDataserieValue, setObjDataserieValue] = useState(__OBJECT_STRUCTURE_GetDataserieValue(inputParam_DataSerie.dataserieId));
    //useGetBoardElementDataserieValue(objDataserieValue, setObjDataserieValue, inputParam_DataSerie.dataserieId, null, inputParam_IsPanelOpen)
    

    const [fireGetEditElement, setFireGetEditElement] = useState({fire : false, dataserieValueId: null, serieTime: null});  
    useGetDataSerieValue(objDataserieValue, setObjDataserieValue, inputParam_DataSerie.dataserieId, fireGetEditElement.dataserieValueId, fireGetEditElement.serieTime, inputParam_IsPanelOpen, fireGetEditElement.fire, setFireGetEditElement)
   
    const aux_userProps = !isNullUndefined(inputParam_UserProps) ? inputParam_UserProps : contextBoard.userPropsKpi.value;

    const editMode = checkIfDataserieValueEditDeleteMode(objDataserieValue);
    const _priv_canEditDataserieValue = _checkSecurityUserAux(contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CREATE, boardElementRoles, systemRoles);
    const _priv_canEditAmountValue = _checkSecurityUser_And_ResponsibleInsert(inputParam_DataSerie.responsibleInsertRole, contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CREATE, boardElementRoles, systemRoles);
   
    const validateForm = () => {
        let isValid =(
            objDataserieValue.dataserieId !== null  &&
            objDataserieValue.serieTime !== null  &&
            objDataserieValue.locked !== null
        ) ? true : false;

        let isValidV12 = true;

        if (inputParam_DataSerie.useOfVariables) {
            isValidForm.v1 = !isNullUndefinedOrEmpty(objDataserieValue.v1)

            if (inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE) {
                isValidForm.v2 = !isNullUndefinedOrEmpty(objDataserieValue.v2)
            }
            else {
                isValidForm.v2 = true;
            }

            isValidForm.valueReal = true
            isValidForm.valueProvisory = true
            isValidForm.valueBudget = true
            isValidForm.valueForecast = true
            
            isValidV12 =   (
                (inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE ?
                    ((isValidForm.v1 && isValidForm.v2)) : isValidForm.v1
                )
            );

            if (inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE) {
                if (isNullUndefinedOrEmpty(objDataserieValue.v1) && isNullUndefinedOrEmpty(objDataserieValue.v2)) {
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata-wvariables'))
                }
                else {
                    if (isNullUndefinedOrEmpty(objDataserieValue.v1) && !isNullUndefinedOrEmpty(objDataserieValue.v2)) {
                        isValid = false;
                        isValidForm.v1 = false;
                    }
                    if (isNullUndefinedOrEmpty(objDataserieValue.v2) && !isNullUndefinedOrEmpty(objDataserieValue.v1)) {
                        isValid = false;
                        isValidForm.v2 = false;
                    }
    
                    if (!isValidV12) {
                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata-wvariables'))
                    }
                }
            }
            else {
                if (isNullUndefinedOrEmpty(objDataserieValue.v1)) {
                    if (!isValidV12) {
                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata-wvariable'))
                    }
                    else {
                        if (!isValid) {
                            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata'))
                        }
                    }
                }
            }    
        }
        else {
            isValidForm.valueReal = !isNullUndefinedOrEmpty(objDataserieValue.valueReal)
            isValidForm.valueProvisory = !isNullUndefinedOrEmpty(objDataserieValue.valueProvisory)
            isValidForm.valueBudget = !isNullUndefinedOrEmpty(objDataserieValue.valueBudget)
            isValidForm.valueForecast = !isNullUndefinedOrEmpty(objDataserieValue.valueForecast)
            isValid = (isValidForm.valueReal || isValidForm.valueProvisory || isValidForm.valueBudget || isValidForm.valueForecast);

            if (isValid) {
                isValidForm.valueReal = isValid
                isValidForm.valueProvisory = isValid
                isValidForm.valueBudget = isValid
                isValidForm.valueForecast = isValid
            }

            if (!isValid) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata'))
            }
        }

        setIsValidForm(isValidForm)

        return isValid && isValidV12
    }

    const handleSelect = (value) => {
        setObjDataserieValue(prevState => ({
            ...prevState,               
            serieTime : value,
        }));
    }

    const [calendarConfig, setCalendarConfig] = useState({
        maxDetail:null,//decade, year, month
        minDetail:"century",
        selectRange:false,
        showDoubleView:false,
        onChange:handleSelect,
        returnValue:"start"
    });
    useManipulateCalendarType(calendarConfig, setCalendarConfig, inputParam_ElementType, inputParam_IsPanelOpen, inputParam_DataSerie.measurementPeriodId, setObjDataserieValue)
  
    const onClickMonth = (value) => {
        let date = moment(value);
        date.startOf('day');
        date.set('hour', objDataserieValue.wildcard !== null ? objDataserieValue.wildcard : 0);

        setObjDataserieValue(prevState => ({
            ...prevState, 
            id: null,              
            serieTime : date.toDate(),
        }));
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = async () => {
        showMessage(setMessageConfig, false, null, null)
        setIsValidForm({
            v1: true,
            v2: true,
            valueReal: true,
            valueProvisory: true,
            valueBudget: true,
            valueForecast: true,
        });

        setObjDataserieValue(__OBJECT_STRUCTURE_GetDataserieValue(null));
        setDataserievalueList(__OBJECT_STRUCTURE_GetList())

        setCalendarConfig(prevState => ({
            ...prevState,
            maxDetail:null,//decade, year, month
        })) 
        
        /*if (inputParam_ElementId !== null) {
            const startDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate !== null ? moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MM/DD/YYYY') : null;
            const endDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate !== null ? moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('MM/DD/YYYY') : null;
        
            const elementDataserieResponse = await getBoardVariableDataSerieValues(
                inputParam_BoardId,
                inputParam_ElementId,
                null,
                contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId,
                startDate,
                endDate
            );
            if (elementDataserieResponse.data.succeeded) {
                dispatch(action_setBoardViewVariableDataserieValues(elementDataserieResponse.data.data))
            }
        }*/

        setIsInvalidForm(false)
        inputParam_SetterIsPanelOpen(false);
    };

    const onEditFromListClick = (item ) => {
        //##Ver manipulacion de serie time cuando posee numeros adicionales de turno.
        const fecha = moment(item.serieTime, 'YYYYMMDDHHmm');

        const formatoDeseado = 'MM-DD-YYYY';
        const fechaFormateada = fecha.format(formatoDeseado);

        setFireGetEditElement({
            fire : true,
            dataserieValueId : item.id,
            serieTime: fechaFormateada
        })

        setIsInvalidForm(false);
        setShowEditForm(true);
        setPreventDoubleExecutionAction(false);
    };

    const onLockDataserieValueClick = (item, locked) => {
        postDataserieValueLocked(inputParam_ElementId, item.id).then((response) => {
            if (response.data.succeeded) {

                if (dataserievalueList.data !== undefined) {
                    dataserievalueList.data.forEach(element => {
                        if (item.id === element.id) {
                            element.locked = locked;
                        }
                    });
                }
                else {
                    dataserievalueList.forEach(element => {
                        if (item.id === element.id) {
                            element.locked = locked;
                        }
                    });
                }
                
                setDataserievalueList(dataserievalueList);
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };

    
    const onEditItem = async () => {
        setPreventDoubleExecutionAction(true);

        let newobj = null

        objDataserieValue.v1 = objDataserieValue.v1 !== undefined ? (!isNullOrEmpty(objDataserieValue.v1) ? parseFloat(objDataserieValue.v1.toString().replace(',','.')) : objDataserieValue.v1) : null;
        objDataserieValue.v2 = objDataserieValue.v2 !== undefined ? (!isNullOrEmpty(objDataserieValue.v2) ? parseFloat(objDataserieValue.v2.toString().replace(',','.')) : objDataserieValue.v2) : null;
        objDataserieValue.valueReal = objDataserieValue.valueReal !== undefined ? (!isNullOrEmpty(objDataserieValue.valueReal) ? parseFloat(objDataserieValue.valueReal.toString().replace(',','.')) : objDataserieValue.valueReal) : null;
        objDataserieValue.valueProvisory = objDataserieValue.valueProvisory !== undefined ? (!isNullOrEmpty(objDataserieValue.valueProvisory) ? parseFloat(objDataserieValue.valueProvisory.toString().replace(',','.')) : objDataserieValue.valueProvisory) : null;
        objDataserieValue.valueBudget = objDataserieValue.valueBudget !== undefined ? (!isNullOrEmpty(objDataserieValue.valueBudget) ? parseFloat(objDataserieValue.valueBudget.toString().replace(',','.')) : objDataserieValue.valueBudget) : null;
        objDataserieValue.valueForecast = objDataserieValue.valueForecast !== undefined ? (!isNullOrEmpty(objDataserieValue.valueForecast) ? parseFloat(objDataserieValue.valueForecast.toString().replace(',','.')) : objDataserieValue.valueForecast) : null;
        objDataserieValue.valueGoal = objDataserieValue.valueGoal !== undefined ? (!isNullOrEmpty(objDataserieValue.valueGoal) ? parseFloat(objDataserieValue.valueGoal.toString().replace(',','.')) : objDataserieValue.valueGoal) : null;

        newobj = {...objDataserieValue};
        newobj.serieTime = moment(objDataserieValue.serieTime).format('YYYYMMDDHHmmss');

        if (validateForm()) {    
            await editDataSerieValue(newobj).then(async (response) => {
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    !showFinishButton && setShowFinishButton(true)

                    const obJFilters = contextSite.kpiModule.boardCalendarFilterConfig.value;

                    const startDate = obJFilters.calendarSelectorId === enum__BoardCalendarFilter.FIXED_MONTH ? obJFilters.periodStartDate !== null ? moment(obJFilters.periodStartDate).format('MM/DD/YYYY') : null : null;
                    const endDate = obJFilters.calendarSelectorId === enum__BoardCalendarFilter.FIXED_MONTH ? obJFilters.periodEndsDate !== null ? moment(obJFilters.periodEndsDate).format('MM/DD/YYYY') : null : null;
                    
                    const serviceSerieResponse = await getBoardVariableDataSerieValues(inputParam_BoardId, inputParam_DataSerie.elementId, inputParam_DataSerie.dataserieId, obJFilters.calendarSelectorId, enum__KPIAgregationTypes.NO_AGG, startDate, endDate);
    
                    let elementDataserie = serviceSerieResponse.data.data.find(x => x.dataserieId === inputParam_DataSerie.dataserieId)

                    setDataserievalueList(prevState => ({
                        ...prevState,
                        fireUpdate:true,
                        data: elementDataserie.l_vals
                    }));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }

                setShowEditForm(false)
                setPreventDoubleExecutionAction(false);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setPreventDoubleExecutionAction(false);
            });
        }
        else {
            setIsInvalidForm(true)
            setPreventDoubleExecutionAction(false);
        }
    };

    const onSelectionHourChange = (selectedValues) => {
        let aux_value =  selectedValues.length > 0 ? selectedValues[0].key : null;
        
        objDataserieValue.serieTime = new Date(new Date(objDataserieValue.serieTime).setHours(aux_value/100))

        setObjDataserieValue(prevState => ({
            ...prevState, 
            id: null,
            serieTime: objDataserieValue.serieTime,
            wildcard : aux_value,
        }));
    };

    const onShiftChange = (control, option) => {
        let aux_value =  option.key;
        
        objDataserieValue.serieTime = new Date(new Date(objDataserieValue.serieTime).setHours(0, aux_value, 0, 0))

        setObjDataserieValue(prevState => ({
            ...prevState, 
            id: null,
            serieTime: objDataserieValue.serieTime,
            wildcard : aux_value,
        }));
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        /*contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
            ...prevState,
            fireFilter: true
        }))*/

        //setBoardVariableDataserieValues(null)
        
        //window.location.href = window.location.href;

        dispatch(action_setPageState(false));
        dispatch(action_setBoardContractFilterComponents_And_Sync_Flag(__OBJECT_STRUCTURE_BoardFilters(), false));

        onDismissPanel();
    };

    const onRebindDataserieValueList = () => {
        setShowEditForm(false);
        setDocumentLinkList(null)
        setObjDataserieValue(__OBJECT_STRUCTURE_GetDataserieValue(inputParam_DataSerie.dataserieId))
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        {
                            dataserievalueList.data !== null &&
                            <ListPagination
                                listLocalStoragePageSizeVariableName="dataserieValueEditPanel"
                                data={ dataserievalueList }
                                setData={ setDataserievalueList }
                            />
                        }
                    </Col>
                    <Col className="pt-2">
                        <MessageBoxInfoComplex
                            inputParam_Width="100%"
                            inputParam_Message={`
                                ${t('data-lang-msg-adddataserievaluehierarchy')}:  
                                <b>1) ${t('data-lang-lbl-field-valueReal')},  
                                2) ${t('data-lang-lbl-field-valueProvisory')},  
                                3) ${t('data-lang-lbl-field-valueBudget')},  
                                4) ${t('data-lang-lbl-field-valueForecast')}.</b>
                            `}
                        />
                        {
                            inputParam_DataSerie.useOfVariables &&
                            <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-adddataserievalueformulavalue')} (${t('data-lang-lbl-field-valueReal')}).`} />
                        }
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            objDataserieValue.id !== null && objDataserieValue.id !== 0 && editMode && (_priv_canEditDataserieValue.value || _priv_canEditAmountValue.value) && showEditForm && !preventDoubleExecutionAction &&
                            <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        }
                        {
                            <DefaultButton className='me-2' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                        }
                        {
                            showEditForm &&
                            <DefaultButton onClick={ () => onRebindDataserieValueList() }>{ t('data-lang-btn-backtolist') }</DefaultButton>
                        }
                    </Col>
                </Row>
    }

    const testTags = __HoursValues.map(item => ({ key: item.key, name: item.value }));
      
    const listContainsTagList = (tag, tagList) => {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.some(compareTag => compareTag.key === tag.key);
    };


    const filterSuggestedTags = (filterText, tagList) => {
        return filterText
            ? testTags.filter(
                tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 && !listContainsTagList(tag, tagList),
            )
        : [];
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-editdataserievalue') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-variablename') } labelValue={ `${inputParam_DataSerie.variableName} (${inputParam_DataSerie.um})` }  />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-period') } labelValue={ t(__KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).text) }  />
                    </Col>
                </Row>
                {
                    showEditForm &&
                    <>
                        <Row className="pt-3">
                            <Col>
                                <div className={ calendarConfig.maxDetail === "month" ? 'calendar-layer-block-simple' : 'calendar-layer-block-simple-small'}>
                                {
                                    calendarConfig.maxDetail &&
                                    <Calendar
                                        className={"disabledbutton mx-auto"}
                                        onChange={onClickMonth}
                                        returnValue={calendarConfig.returnValue}
                                        value={objDataserieValue.serieTime !== null ? new Date(objDataserieValue.serieTime) : new Date()}
                                        selectRange={calendarConfig.selectRange}
                                        showNeighboringMonth={false}
                                        maxDate={new Date()}
                                        minDetail={calendarConfig.minDetail}
                                        maxDetail={calendarConfig.maxDetail}
                                        showDoubleView={calendarConfig.showDoubleView}
                                        formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                        locale={"es-ES"}
                                        //tileDisabled={ ({date}) => inputParam_PeriodList.filter(x => x.text === date.getFullYear().toString()).length === 0 }
                                    />
                                }
                                <div className='box overlay'></div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            {
                                inputParam_DataSerie.measurementPeriodId === 5 &&
                                <Col xl={6}>
                                    <Dropdown
                                        placeholder="Turno"
                                        label="Turno"
                                        options={__ShiftValues}
                                        disabled={true}
                                        styles={{ width: 50 }}
                                        onChange={onShiftChange}
                                        selectedKey={objDataserieValue.wildcard}
                                    />
                                </Col>
                            }
                            {
                                inputParam_DataSerie.measurementPeriodId === 4 &&
                                <Col xl={6}>
                                    <label className='ms-Label custom-txt-root'>{t('data-lang-lbl-hour')}</label>
                                    <TagPicker
                                        removeButtonAriaLabel="Remove"
                                        selectionAriaLabel={t('data-lang-lbl-selectedhour')}
                                        onResolveSuggestions={() => testTags}
                                        getTextFromItem={(item) => item.name}
                                        pickerSuggestionsProps={{
                                            suggestionsHeaderText: t('data-lang-lbl-suggestedhour'),
                                            noResultsFoundText: t('data-lang-lbl-hournotfound'),
                                        }}
                                        itemLimit={1}
                                        disabled={true}
                                        selectedItems={objDataserieValue.wildcard !== null ? [testTags.find(x => x.key === parseInt(objDataserieValue.wildcard))] : []}
                                        onChange={onSelectionHourChange}
                                        pickerCalloutProps={{ doNotLayer: true }}
                                    />
                                </Col>
                            }
                        </Row>
                        {
                            inputParam_DataSerie.useOfVariables &&
                            <Row className="py-3 mt-3 border rounded-1">
                                <Col xl={6}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-formula')} labelValue={objDataserieValue.formulaDesc}  />
                                </Col>
                                <Col xl={6}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-objetive')} labelValue={objDataserieValue.variableObjetive}  />
                                </Col>
                                <Col xl={6}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k1')} labelValue={objDataserieValue.k1}  />
                                </Col>
                                <Col xl={6}>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k2')} labelValue={objDataserieValue.k2}  />
                                </Col>
                                <Col xl={6}>
                                    <CCurrencyTextBox
                                        labelText={`${t('data-lang-lbl-field-v1')} - ${!isNullUndefinedOrEmpty(inputParam_DataSerie.v1Name) ? inputParam_DataSerie.v1Name : '' }`}
                                        controlValue={objDataserieValue.v1}
                                        objectPropertyNameForSetter={"v1"}
                                        setterIsPropertyObject={true}
                                        isInvalidControl={ !isValidForm.v1 }
                                        setterControlValue={setObjDataserieValue}
                                        object={objDataserieValue}
                                        disabled={!editMode && !(_priv_canEditDataserieValue.value || _priv_canEditAmountValue.value)}
                                    />
                                </Col>
                                <Col xl={6}>
                                {
                                    inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE &&
                                    <CCurrencyTextBox
                                        labelText={`${t('data-lang-lbl-field-v2')} - ${!isNullUndefinedOrEmpty(inputParam_DataSerie.v2Name) ? inputParam_DataSerie.v2Name : '' }`}
                                        controlValue={objDataserieValue.v2}
                                        objectPropertyNameForSetter={"v2"}
                                        setterIsPropertyObject={true}
                                        isInvalidControl={ !isValidForm.v2 }
                                        setterControlValue={setObjDataserieValue}
                                        object={objDataserieValue}
                                        disabled={!editMode && !(_priv_canEditDataserieValue.value || _priv_canEditAmountValue.value)}
                                    />
                                }
                                </Col>
                            </Row>
                        }
                        <Row className="pt-3">
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueReal')}
                                    controlValue={objDataserieValue.valueReal}
                                    objectPropertyNameForSetter={"valueReal"}
                                    setterIsPropertyObject={true}
                                    isInvalidControl={ isInvalidForm ? objDataserieValue.valueReal === null : false }
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    invalidText=""
                                    disabled={!editMode && !_priv_canEditDataserieValue.value}
                                />
                            </Col>
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueProvisory')}
                                    controlValue={objDataserieValue.valueProvisory}
                                    objectPropertyNameForSetter={"valueProvisory"}
                                    setterIsPropertyObject={true}
                                    isInvalidControl={ false }
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    invalidText=""
                                    disabled={!editMode && !_priv_canEditDataserieValue.value}
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueBudget')}
                                    controlValue={objDataserieValue.valueBudget}
                                    objectPropertyNameForSetter={"valueBudget"}
                                    setterIsPropertyObject={true}
                                    isInvalidControl={ false }
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    invalidText=""
                                    disabled={!editMode && !_priv_canEditDataserieValue.value}
                                />
                            </Col>
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueForecast')}
                                    controlValue={objDataserieValue.valueForecast}
                                    objectPropertyNameForSetter={"valueForecast"}
                                    setterIsPropertyObject={true}
                                    isInvalidControl={ false }
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    invalidText=""
                                    disabled={!editMode && !_priv_canEditDataserieValue.value}
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CCurrencyTextBox
                                    labelText={t('data-lang-lbl-field-valueGoal')}
                                    controlValue={objDataserieValue.valueGoal}
                                    objectPropertyNameForSetter={"valueGoal"}
                                    setterIsPropertyObject={true}
                                    isInvalidControl={ false }
                                    setterControlValue={setObjDataserieValue}
                                    object={objDataserieValue}
                                    invalidText=""
                                    disabled={!_priv_canEditDataserieValue.value}
                                />
                            </Col>
                            {
                                objDataserieValue.id !== 0 && objDataserieValue.id !== null &&
                                <Col>
                                    <CCurrencyTextBox
                                        labelText={t('data-lang-lbl-field-valueGoalPercent')}
                                        controlValue={objDataserieValue.valueGoalPercent}
                                        objectPropertyNameForSetter={"valueGoalPercent"}
                                        setterIsPropertyObject={true}
                                        isInvalidControl={ false }
                                        disabled={true}
                                        setterControlValue={setObjDataserieValue}
                                        object={objDataserieValue}
                                    />
                                </Col>
                            }
                        </Row>
                        {
                            objDataserieValue.id !== null && objDataserieValue.id !== 0 &&
                            <DataserieValueDocumentBox
                                inputParam_IsPanelOpen={inputParam_IsPanelOpen}
                                inputParam_ObjDataserieValueId={objDataserieValue.id}
                                inputParam_SetMessageConfig={setMessageConfig}
                                inputParam_EditMode={editMode && (_priv_canEditDataserieValue.value || _priv_canEditAmountValue.value)}    
                                inputParam_DocumentLinkList={documentLinkList}
                                inputParam_SetDocumentLinkList={setDocumentLinkList}
                            />
                        }
                    </>
                }
                <>
                    <Row className="pt-3" style={{display: showEditForm ? "none" : "unset"}}>
                        <Col>
                            <h6><CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-dataserievalues') } labelValue={ null }  /></h6>
                        </Col>
                    </Row>
                    <Row className="pt-3" style={{display: showEditForm ? "none" : "unset"}}>
                        <Col xl={12}>
                            <List
                                listLocalStoragePageSizeVariableName="partyCreationUsers"
                                showHeaders={false}
                                manipulateLocalData={ true }
                                setData={setDataserievalueList}
                                data={dataserievalueList}
                                columns={[
                                    {
                                        key: 'serieTime',
                                        name: t('data-lang-lbl-field-serieTimeStr'),
                                        fieldName: 'serieTimeStr',
                                        minWidth: 90,
                                        maxWidth: 90,
                                        onRender:(item) => {
                                            return <div data-dataserievalue-id={item.id}>{ item.serieTimeStr }</div>
                                        }
                                    },
                                    {
                                        key: 'displayValue',
                                        name: t('data-lang-lbl-field-displayValue'),
                                        fieldName: 'displayValue',
                                        minWidth: 105,
                                        maxWidth: 105,
                                        onRender:(item) => {
                                            return <div>{ item.displayValue }</div>
                                        }
                                    },
                                    {
                                        key: 'valueGoal',
                                        name: t('data-lang-lbl-field-valueGoal'),
                                        fieldName: 'valueGoal',
                                        minWidth: 105,
                                        maxWidth: 105,
                                        onRender:(item) => {
                                            return <div>{ item.valueGoal }</div>
                                        }
                                    },
                                    {
                                        key: 'valueGoalPercent',
                                        name: t('data-lang-lbl-field-valueGoalPercent'),
                                        fieldName: 'valueGoalPercent',
                                        minWidth: 65,
                                        maxWidth: 65,
                                        onRender:(item) => {
                                            return <div>{ item.valueGoalPercent }</div>
                                        }
                                    },
                                    {  
                                        key: 'id',
                                        name: t('data-lang-lbl-actions'),
                                        fieldName: 'id',
                                        minWidth: 85,
                                        maxWidth: 85,
                                        onRender:(item, row) => {
                                            return  <>
                                                        {
                                                            !item.locked ?
                                                            <>
                                                                <ActionButton id={`btnMantEdit${item.id}`} iconProps={{ iconName: 'Edit' }} onClick={() => onEditFromListClick(item)} allowDisabledFocus />
                                                                {
                                                                    <ActionButton id={`btnMantLock${item.id}`} iconProps={{ iconName: 'Unlock' }} onClick={() => onLockDataserieValueClick(item, true)} allowDisabledFocus />
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                <ActionButton id={`btnMantEdit${item.id}`} iconProps={{ iconName: 'Edit' }} onClick={undefined} disabled={true} allowDisabledFocus />
                                                                {
                                                                    <ActionButton id={`btnMantLock${item.id}`} iconProps={{ iconName: 'Lock' }} onClick={() => onLockDataserieValueClick(item, false)} allowDisabledFocus />
                                                                }
                                                            </>
                                                        }
                                                        {
                                                            (!isNullUndefinedOrEmpty(item.hasDocuments) && item.hasDocuments) &&
                                                            <Icon iconName={'DocumentApproval'} allowDisabledFocus title={t('data-lang-lbl-hasdocument')} />
                                                        }
                                                    </>     
                                        }
                                    }
                                ]}
                            />
                        </Col>
                    </Row>
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelEditDataserieVariableValue.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_ElementType: PropTypes.string.isRequired,
};

export default SidePanelEditDataserieVariableValue;